import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { MarqueeStrip } from "@/components/landing/MarqueeStrip";
import { Services } from "@/components/landing/Services";
import { Extras } from "@/components/landing/Extras";
import { JobsSection } from "@/components/landing/JobsSection";
import { HowItWorks } from "@/components/landing/HowItWorks";
import { HireUs } from "@/components/landing/HireUs";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";

const DEFAULT_SETTINGS = {
  company_name: "PRGL",
  tagline: "Van & Crew Delivery Specialists",
  phone: "07931935173",
  whatsapp: "07931935173",
  email: "bookings@PRGL.co.uk",
  domain: "prgl.co.uk",
  address: "Bristol, United Kingdom",
  facebook_url: "#",
  instagram_url: "#",
  hero_headline: "Vans and crews, ready when you need them",
  hero_subtext: "PRGL supplies fully-equipped vans and trained two-man crews for deliveries, removals and installations across every sector — home, retail, construction and more. Book in minutes, often moving within 24 hours.",
};

export default function Landing() {
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);
  const [jobs, setJobs] = useState([]);

  useEffect(() => {
    api.get("/settings").then((res) => setSettings(res.data)).catch(() => {});
    api.get("/jobs").then((res) => setJobs(res.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="landing-page" className="min-h-screen bg-white">
      <Navbar />
      <main>
        <Hero settings={settings} />
        <HireUs />
        <MarqueeStrip />
        <Services />
        <Extras />
        <HowItWorks />
        <JobsSection jobs={jobs} settings={settings} />
        <Contact settings={settings} />
      </main>
      <Footer settings={settings} />
    </div>
  );
}
